
import Footer from '../../components/footer1';
import Layout from '../../components/layout'
import Topbar from '../../components/topbar';

import Bild from '../../assets/press/johan-lahti-vd-emanuel-lipschutz-styrelseordforande-acebit.jpg'


export default function EmanuelPressPage(props) {
  return (
    <>
      <Topbar />
      <div className="bg-slate-200 dark:bg-gray3 text-lg">
        <div className="flex flex-col items-center sm:gap-0 gap-y-48">
          <Layout >
            <div className="w-full flex flex-col items-center">
              <div className="flex flex-col gap-10 w-2/3">
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-2">
                    <h1 className="text-5xl">Emanuel Lipschütz ny styrelseordförande i nätverks- och automationsexperten Acebit</h1>
                    <div>
                      Falun 2024-12-19
                    </div>
                  </div>
                  <div className="">
                    <img src={Bild} alt="emanuel lipschutz johan lahti styrelseordförande" />
                  </div>
                </div>
                <div className="text-2xl italic">Serieentreprenören och cybersäkerhetsexperten Emanuel Lipschütz går in som styrelseordförande i
                  nätverks- och automationsexperten Acebit. Företaget designar moderna nätverk för såväl privat
                  som offentlig sektor och avser tiodubbla omsättningen till 100 miljoner inom fem år.</div>
                <div className="flex flex-col gap-4">
                  <div>
                    IT-nätverken är idag allt oftare så komplexa att de är ohållbara att hantera manuellt, och medan kunderna söker
                    säkra, automatiserade och leverantörsoberoende lösningar så är kompetensen för detta sällsynt.
                  </div>
                  <div>
                    - Ökad automation i nätverken är ofrånkomlig idag, NIS2 och säkerhetshoten ökar behoven ytterligare. Acebit har en
                    unik expertis i att designa, bygga och arbeta med moderna nät där automationen finns med från början. Under sina
                    fyra år har de visat detta hos en rad av Sveriges största verksamheter, och jag ser fram emot att stötta dem när de nu
                    växlar upp för att ge moderna nätverk till många fler, säger Emanuel Lipschütz.
                  </div>
                  <div>
                    - Många har redan upplevt hur automationsprojekt ovanpå befintliga nät gjort dem både mer leverantörsberoende och
                    mindre lyckliga. På Acebit har vi stor erfarenhet av att alltid arbeta med automation, processer och nätverk som den
                    helhet de måste vara i en validerad designprocess – och ge kunderna det de vill ha, säger Acebits VD och grundare
                    Johan Lahti, och fortsätter:
                  </div>
                  <div>
                    - Emanuel Lipschütz har designat, eller utbildat de som designat, en stor del av Sveriges nätverk. Med hans stöd är
                    jag ännu säkrare på att Acebit kommer att omsätta mer än 100 miljoner 2030, avslutar Lahti.
                    Acebit är en systemintegratör där samtliga konsulter skall kunna såväl nätverk (flera är toppcertifierade av Cisco,
                    CCIE) som programmering. Företaget eftersträvar att arbeta med kunderna och utbilda dem så att kunden kan äga
                    sin egen validerade automationslösning.
                  </div>
                  <div>
                    Emanuel Lipschütz grundade och drev systemintegratören Netsafe, senare en del av Conscia. Emanuel är en av Nordens högst certifierade Cisco-nätverksexperter och av Cisco utsedd till en av deras bästa utbildare i världen. Emanuel har efter att han i augusti lämnat bolaget som han grundade för 27 år, sedan verkat som cybersäkerhetsexpert och rådgivare. Emanuel har också varit founding investor i flera bolag, bla miljardvärderade Insurely.
                  </div>
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-col gap-6">
                      <div className="text-lg">
                        <div className="text-2xl font-semibold">Presskontakt:</div>
                        <div>Johan Lahti, vd och grundare, Acebit - <a href="mailto:johan.lahti@acebit.se" className="text-sky-500">johan.lahti@acebit.se</a>, <a href="tel:0703242600" className="text-sky-500">0703-24 26 00</a></div>
                        <div>Emanuel Lipschütz, styrelseordförande, Acebit - <a href="mailto:emanuel.lipschutz@cloudcomputing.se" className="text-sky-500">emanuel.lipschutz@cloudcomputing.se</a></div>
                      </div>
                      <div className="text-xl">
                        <span className="text-sky-500 font-semibold">Acebit</span> är ett konsultbolag som designar, implementerar och automatiserar infrastruktur inom datacenter,
                        nätverk, säkerhet och telekom. Med start 2020 har Acebit nu kontor i Falun och Västerås. År 2024
                        omsätter Acebit ca 10 MSEK med 8 anställda. För mer information, se <a href="www.acebit.se" target='_blank' className="text-sky-500">www.acebit.se</a>
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Layout>
        </div>
      </div>
      <Footer />
    </>
  )
}
